// import React, { useState } from 'react'
// import ContractLayout from './ContractLayout'
// import { useFormik } from 'formik';
// import ToggleUp from '../../../../Components/Icons/ToggleUp';
// import ToggleDown from '../../../../Components/Icons/ToggleDown';
// import { Progress } from 'antd';

// function FormContract() {
//     const [expandedIndex, setExpandedIndex] = useState(null);

//   const handleToggle = (index) => {
//     setExpandedIndex(expandedIndex === index ? null : index);
//   };
//     const formik = useFormik({
//         enableReinitialize: true,
//         initialValues: createNew,
//         validateOnChange: false,
//         validateOnBlur: false,
       
//         onSubmit: (values) => console.log("Form Submitted", values),
//       });
//   return (
//     <ContractLayout>
//     <div className="w-full h-full  ">
// <div className="w-full mx-auto h-[calc(100vh-145px)]  rounded-md md:overflow-hidden p-2   md:flex gap-2 text-[#111537]">
// <React.Fragment key={index}>
//           <div
//             className="w-full py-2 flex justify-between items-center bg-slate-200 px-3"
//           >
//             <div
//               className="w-3 rounded-md cursor-pointer text-center p-0.5"
//               onClick={() => handleToggle(index)}
//             >
//               {expandedIndex === index ? <ToggleUp /> : <ToggleDown />}
//             </div>

//             <p className="w-[55%] text-left text-xs font-medium text-[#111537]">
//               {form?.title}
//             </p>

//             <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
//               {form?.updatedOn}
//             </p>

//             <div className="w-[15%] py-2 text-xs text-center font-normal text-mainColor-400">
//               <Progress
//                 type="circle"
//                 size={30}
//                 strokeWidth={12}
//                 format={(percent) => (
//                   <p
//                     className={`cursor-pointer ${
//                       form?.completion > 95
//                         ? "text-[#87d068]"
//                         : form?.completion > 50
//                         ? "text-[#108ee9]"
//                         : "text-[#D2BD00]"
//                     } text-xs font-semibold`}
//                   >
//                     {percent}
//                   </p>
//                 )}
//                 percent={Math.floor(form?.completion) || 0}
//                 strokeColor={
//                   form?.completion > 95
//                     ? { "0%": "#87d068", "100%": "#87d068" }
//                     : form?.completion > 50
//                     ? { "0%": "#108ee9", "100%": "#108ee9" }
//                     : { "0%": "#D2BD00", "100%": "#D2BD00" }
//                 }
//               />
//             </div>

//             <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
//               {form?.status}
//             </p>
//           </div>

//           {expandedIndex === index && (
//             <div className="bg-white p-4 border-t border-gray-200">
//               <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                 
//               </form>
//             </div>
//           )}
//         </React.Fragment>
// </div>
// </div>
// </ContractLayout>
//   )
// }

// export default FormContract
import React from 'react'
import ContractLayout from './ContractLayout'

function FormContract() {
  return (
    <ContractLayout>
    <div className="w-full h-full  ">
    <div className="w-full mx-auto h-[calc(100vh-145px)]  rounded-md md:overflow-hidden p-2   md:flex gap-2 text-[#111537]">

    <div className="w-full bg-white p-2  rounded-lg overflow-y-scroll">
FormContract</div>
</div>
</div>
</ContractLayout>
  )
}

export default FormContract